export interface CouponConditionType {
    id: number;
    operatorId: string;
    campaignId: number;
    name: string;
    type: CouponConditionBonusTypeEnum;
    depositType: CouponConditionDepositTypeEnum;
    depositMinimum: number;
    depositPeriodStart?: string;
    depositPeriodEnd?: string;
    turnover: CouponConditionTurnOverEnum;
    amount: number;
    turnoverAmount: number;
    maxAmount: number;
    limitUsePerUser: number;
    limitUsePerUserPerDay: number;
    isActive: boolean;
    descriptions: string;
    codeMode: CouponConditionModeEnum;
    limitUsePerCampaign: number;
    newUserDuration: number;
    hasSchedule?: boolean;
    scheduleStartDate?: string;
    scheduleEndDate?: string;
    scheduleAllDay?: boolean;
    scheduleStartTime?: string;
    scheduleEndTime?: string;
    scheduleRepeatAmount?: number;
    scheduleRepeatUnit?: CouponScheduleRepeatUnitEnum;
    scheduleDaysOfWeek?: CouponScheduleDayOfWeekEnum[];
    scheduleDaysOfMonth?: number[];
    scheduleWeeksOfMonth?: number[];
}

export enum CouponConditionBonusTypeEnum {
    DEPOSIT_PERCENTAGE = 'deposit_percent',
    FIXED_AMOUNT = 'fixed_amount',
    VALIDA_BALANCE_PERCENT = 'valid_balance_percent',
}

export enum CouponConditionModeEnum {
    UNIQUE = 'unique',
    GENERIC = 'generic',
}

export enum CouponConditionDepositTypeEnum {
    NONE = 'none',
    SINGLE_TIME_LATEST = 'single_time_latest',
    MULTIPLE_TIME_LATEST = 'multiple_time_latest',
    CUMULATIVE = 'cumulative',
    PERIOD = 'period',
}

export enum CouponConditionTurnOverEnum {
    FIXED_AMOUNT = 'fixed_amount',
    BONUS_PERCENT = 'bonus_percent',
    NONE = 'none',
}

export enum CouponScheduleRepeatUnitEnum {
    NONE = 'none',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
}

export enum CouponScheduleDayOfWeekEnum {
    SUN = 'sun',
    MON = 'mon',
    TUE = 'tue',
    WED = 'wed',
    THU = 'thu',
    FRI = 'fri',
    SAT = 'sat',
}

export const COUPON_SCHEDULE_WEEKS_OF_MONTH = [
    { value: 1, labelKey: 'week_first' },
    { value: 2, labelKey: 'week_second' },
    { value: 3, labelKey: 'week_third' },
    { value: 4, labelKey: 'week_fourth' },
    { value: -1, labelKey: 'week_last' },
] as const;
